import React, { Component } from "react";

export default class LoginLoading extends Component {
	render() {
		return (
			<div>
				<p className="is-size-6 has-text-centered has-text-inm-dark-purple">{this.props.message}</p>
				<br/>
				<p className="is-size-5 has-text-centered"><i className="fa fa-spin fa-spinner"></i></p>
				<br/>
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/elements/login/loading.jsx